import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const PostManagementForm = lazy(
  () => import('@components/Group/Portfolio/PostManagementForm')
);

/** 포트폴리오 상세 > 사후관리 > 등록/수정하기 */
const PostManagementNew = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <PostManagementForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default PostManagementNew;
